<template>
  <div class="page grid js_show">
    <div class="page__hd" style="margin-top: 5px">
      <h1 class="page__title">佰药汇-门店管理</h1>
      <p class="page__desc">专业药房运营管理专家</p>
    </div>
    <div class="weui-grids" style="margin-top: 5px">
      <a href="javascript:" class="weui-grid" style="width: 100%" @click="handleWorker" v-if="this.formSet.user==null||this.formSet.user.userFlag=='salesman'">
        <div class="weui-grid__icon">
          <img src="../assets/salesman.png" alt="">
        </div>
        <p class="weui-grid__label">我是业务员</p>
      </a>
      <a href="javascript:" class="weui-grid" style="width: 100%" @click="handleBoss" v-if="this.formSet.user==null||this.formSet.user.userFlag=='boss'">
        <div class="weui-grid__icon">
          <img src="../assets/boss.png" alt="">
        </div>
        <p class="weui-grid__label">我是门店负责人</p>
      </a>
      <a href="javascript:" class="weui-grid" style="width: 100%" @click="handleChainBoss" v-if="this.formSet.user==null||this.formSet.user.userFlag=='chain'">
        <div class="weui-grid__icon">
          <img src="../assets/chain_boss.png" alt="">
        </div>
        <p class="weui-grid__label">我是连锁总部</p>
      </a>

      <a href="javascript:" class="weui-grid" style="width: 100%" @click="selfInfo">
        <div class="weui-grid__icon">
          <img src="../assets/visit.png" alt="">
        </div>
        <p class="weui-grid__label">我的个人信息</p>
      </a>
    </div>

  </div>
</template>
<script>
export default {
  data () {
    return {
      formSet: {
        user: {}
      }

    }
  },
  methods: {

    // 门店负责人
    handleBoss () {
      this.$router.push({path: 'bossShops'})
    },

    // 连锁总店
    handleChainBoss () {
      this.$router.push({path: 'chainShops'})
    },

    // 业务员
    handleWorker () {
      this.$router.push({path: 'deptMan'})
    },

    // 个人信息
    selfInfo () {
      // if (this.formSet.user!=null&&this.formSet.user.userFlag==='boss'){
      //   this.$router.push({path: 'bossInfo'})
      // }else if (this.formSet.user!=null&&this.formSet.user.userFlag==='salesman'){
      //   this.$router.push({path: 'workInfo'})
      // }else if (this.formSet.user!=null&&this.formSet.user.userFlag==='chain'){
      //   this.$router.push({path: 'chainInfo'})
      // }else{
      //   this.$router.push({path: 'workInfo'})
      // }
      if (this.formSet.user !== null && this.formSet.user.userFlag === 'boss') {
        this.$router.push({path: 'bossInfo'})
      } else if (this.formSet.user !== null && this.formSet.user.userFlag === 'salesman') {
        this.$router.push({path: 'workInfo'})
      } else if (this.formSet.user !== null && this.formSet.user.userFlag === 'chain') {
        this.$router.push({path: 'chainInfo'})
      } else {
        this.$router.push({path: 'workInfo'})
      }
    }
  },
  mounted () {
    this.formSet.user = this.$storage.fetchStorage('user')
    if (this.formSet.user === null) {

    }
  },
  components: {

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/systemRegister.vue